export const CHECKOUT_URL = 'https://padel-coach-pro.impultienda.ar/checkout'

export const BUY_ANCHOR = 'buy'

export function scrollToBuy(): void {
  const el = document.getElementById(BUY_ANCHOR)
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

export const IMAGES = {
  boxSet:
    'https://cdn.magicpatterns.com/uploads/edRzXVxRRa1mBwJdFy4Jsp/Diseno_sin_titulo.png',
  bonus1:
    'https://cdn.magicpatterns.com/uploads/6aivKyHF1piiWZK2me3Af6/48157cf0-4b49-458a-a63c-0fbc11258dda-mockup.webp',
  bonus2:
    'https://cdn.magicpatterns.com/uploads/k78JnjhaD1UwhTfgrPKZmg/f830de71-a1f9-4dbf-8a18-981918842a64-mockup.webp',
  bonus3:
    'https://cdn.magicpatterns.com/uploads/fhL654enSTU4wkog4zgy4e/bf24452b-fcc9-4b44-8497-158764ea81bf-mockup.webp',
  bonus4:
    'https://cdn.magicpatterns.com/uploads/3EN9kycayoj32KzP2ziLNE/959f15d8-1efe-4bd4-9288-fdef7c45dc57-mockup.webp',
  bonus5:
    'https://cdn.magicpatterns.com/uploads/nvA7bzagqi6XQRYkXxcd1V/c036d179-3122-47d0-bd06-6107a2bde669-mockup.webp',
}
